import { gql } from '@apollo/client'
import { REQUEST_BASIC_PROPS, PURCHASED_BASIC_PROPS } from './fragments'

export const IS_LOGGED_IN = gql`
  {
    isLoggedIn @client
    userInfo @client {
      id
      email
      name
    }
  }
`

export const CURRENT_USER = gql`
  {
    currentUser {
      id
      email
      name
    }
  }
`

export const USER_INFO = gql`
  {
    userInfo {
      id
      email
      name
      billingInfo {
        email
        name
        company
        country
        address
        city
        zip
        phone
        vat
        extraInfo
      }
      messages {
        time
        id
        content
        author
      }
      supervision {
        ...RequestBasicProps
      }
      quote {
        ...RequestBasicProps
      }
      purchased {
        ...PurchasedBasicProps
      }
    }
  }
  ${REQUEST_BASIC_PROPS}
  ${PURCHASED_BASIC_PROPS}
`
